<template>
  <div class="hotGame">
      <div class="hotGame_banner">
        <div class="hotGame_bannerItem" @click="toGame(item.id)" v-for="(item,index) in gameList" :key = 'index' v-show="index<=1">
          <img :src="item.banner" alt="" />
        </div>
      </div>
      <GameList :gameList="gameList"/>
   
  </div>
</template>
<script>
import GameList from "@/components/gameList.vue";
export default {
  name: "hotGame",
  props:['list'],
  components: {
    GameList
  },
  data() {
    return {
      gameList:[],
    };
  },
  created() {},
  mounted() {
    this.gameList = this.list;
  },
  methods: {
    toGame(id) {
      this.$router.push({ name: "game", query: { id: id } });
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}
.hotGame {
  @include flex_box(column, none, stretch);
   
  .hotGame_banner {
    margin-top: 0.14rem;
    @include flex_box(row, center, stretch);
  }
  .hotGame_bannerItem {
    margin: 0 0.08rem;
    @include flex_box(row, center, center);
    border-radius: 0.1rem;
    img {
      width: 3.52rem;
      height: 1.8rem;
      border-radius: 0.1rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/hotGame.vue